function S(n) {
  const t = n, o = t.parentId ?? t.parentID ?? t.parent_id;
  if (typeof o == "string" && o.trim()) return o.trim();
  const e = t.parent;
  if (e && typeof e == "object" && typeof e.id == "string")
    return e.id;
}
function g(n) {
  const t = n, o = t.tool ?? t.name;
  if (t.type !== "tool" && t.type !== "tool-call" && t.type !== "tool-invocation" || o !== "task") return;
  const i = (t.state ?? {}).metadata ?? t.metadata ?? {}, s = i.sessionId ?? i.session_id ?? i.sessionID;
  return typeof s == "string" && s.trim().length > 0 ? s.trim() : void 0;
}
function I(n) {
  const t = g(n);
  if (!t) return null;
  const o = n, e = o.state ?? {}, i = e.input ?? {}, s = o.id;
  return {
    childSessionId: t,
    taskPartId: typeof s == "string" ? s : void 0,
    agentName: typeof i.subagent_type == "string" ? i.subagent_type : typeof i.subagentType == "string" ? i.subagentType : void 0,
    title: typeof e.title == "string" ? e.title : typeof i.description == "string" ? i.description : void 0
  };
}
function u(n, t) {
  const o = t?.length ? t : n.parts ?? [], e = [], i = /* @__PURE__ */ new Set();
  for (const s of o) {
    const d = I(s);
    !d || i.has(d.childSessionId) || (i.add(d.childSessionId), e.push(d));
  }
  return e;
}
function y(n, t) {
  for (let o = t; o >= 0; o--) {
    if ((n[o].info.role ?? "assistant") === "user")
      return o + 1;
    if (o === 0) return 0;
  }
  return 0;
}
function v(n) {
  for (let t = n.length - 1; t >= 0; t--)
    if ((n[t].info.role ?? "assistant") === "user") return t;
  return -1;
}
function l(n, t, o, e) {
  e[t]?.parentSessionId === o && n.add(t);
}
function m(n, t, o, e, i) {
  const s = /* @__PURE__ */ new Set(), d = y(n, t);
  for (let a = d; a <= t; a++) {
    const r = n[a], c = r.info.id, f = c && o[c]?.length ? o[c] : void 0;
    for (const p of u(r, f))
      l(s, p.childSessionId, e, i);
  }
  return s;
}
function b(n, t, o, e, i) {
  const s = /* @__PURE__ */ new Set(), d = v(n) + 1;
  for (let r = d; r < n.length; r++) {
    const c = n[r], f = c.info.id, p = f && t[f]?.length ? t[f] : void 0;
    for (const h of u(c, p))
      l(s, h.childSessionId, e, i);
  }
  for (const r of u({
    parts: []
  }, o))
    l(s, r.childSessionId, e, i);
  const a = new Set(n.map((r) => r.info.id).filter((r) => typeof r == "string" && r.length > 0));
  for (const [r, c] of Object.entries(t))
    if (!(a.has(r) || !c?.length))
      for (const f of u({
        parts: []
      }, c))
        l(s, f.childSessionId, e, i);
  return s;
}
export {
  u as collectTaskDelegations,
  b as embeddedChildIdsForActiveTurn,
  m as embeddedChildIdsForTurn,
  S as sessionParentId,
  g as taskChildSessionIdFromPart,
  I as taskDelegationInfoFromPart
};
